import React from 'react';
import { SafeImg } from '../../SafeImg';
import { Btn, H1, Eyebrow, tidFor, E } from './_shared';

/* ════════════════════════════════════════════════════════════════════════
 * FORM — new variants (auth-signup, auth-signin, payment-method, billing-account)
 * ════════════════════════════════════════════════════════════════════════ */
export function FormExt({ block, theme, E: EProps = {} }) {
  const { onEdit } = EProps;
  const c = block.content || {};
  const tid = tidFor(block);
  const layout = block.layout;

  if (layout === 'auth-signup') {
    return (
      <section data-block-type={block.type} data-layout={block.layout || "default"} className="px-6 py-16" style={{ background: theme.bg, color: theme.ink }}>
        <div className="max-w-md mx-auto p-8 border border-gray-200 rounded-2xl shadow-lg" style={{ borderRadius: theme.radius || 16 }}>
          <h2 data-testid={tid('title')} className="text-2xl font-bold text-center" style={{ fontFamily: theme.headingFont }}>{c.title || 'Create an Account'}</h2>
          <E block={block} onEdit={onEdit} field='tagline' value={c.tagline || ''} tag='p' className="text-center mt-2 text-sm opacity-70" placeholder='Tagline (optional)' />
          <div className="mt-6 space-y-3">
            <input type="text" placeholder={c.name_label || 'Full Name'} className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm" />
            <input type="email" placeholder={c.email_label || 'Email'} className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm" />
            <input type="password" placeholder={c.password_label || 'Password'} className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm" />
          </div>
          <button className="mt-6 w-full py-3 rounded-full text-sm font-bold uppercase tracking-wider text-white" style={{ background: theme.accent || '#2DD4BF' }}>{c.submit_label || 'Sign Up'}</button>
          <p className="mt-4 text-center text-xs opacity-60">Already have an account? <a href="#" className="font-bold" style={{ color: theme.accent }}>Sign In</a></p>
        </div>
      </section>
    );
  }

  if (layout === 'auth-signin') {
    return (
      <section data-block-type={block.type} data-layout={block.layout || "default"} className="px-6 py-16" style={{ background: theme.bg, color: theme.ink }}>
        <div className="max-w-md mx-auto p-8 border border-gray-200 rounded-2xl shadow-lg" style={{ borderRadius: theme.radius || 16 }}>
          <h2 data-testid={tid('title')} className="text-2xl font-bold text-center" style={{ fontFamily: theme.headingFont }}>{c.title || 'Sign In'}</h2>
          <div className="mt-6 space-y-3">
            <input type="email" placeholder={c.email_label || 'Email'} className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm" />
            <input type="password" placeholder={c.password_label || 'Password'} className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm" />
          </div>
          <div className="mt-3 flex justify-between text-xs"><label className="flex items-center gap-1 opacity-70"><input type="checkbox" /> Remember me</label><a href="#" className="font-bold" style={{ color: theme.accent }}>Forgot?</a></div>
          <button className="mt-6 w-full py-3 rounded-full text-sm font-bold uppercase tracking-wider text-white" style={{ background: theme.accent || '#2DD4BF' }}>{c.submit_label || 'Sign In'}</button>
        </div>
      </section>
    );
  }

  if (layout === 'payment-method') {
    return (
      <section data-block-type={block.type} data-layout={block.layout || "default"} className="px-6 py-16" style={{ background: theme.bg, color: theme.ink }}>
        <div className="max-w-lg mx-auto p-8 border border-gray-200 rounded-2xl" style={{ borderRadius: theme.radius || 16 }}>
          <h2 data-testid={tid('title')} className="text-2xl font-bold" style={{ fontFamily: theme.headingFont }}>{c.title || 'Choose Your Payment Method'}</h2>
          <E block={block} onEdit={onEdit} field='tagline' value={c.tagline || ''} tag='p' className="mt-2 text-sm opacity-70" placeholder='Tagline (optional)' />
          <div className="mt-6 space-y-4">
            <input type="text" placeholder="Cardholder Name" className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm" />
            <input type="text" placeholder="Card Number" className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm" />
            <div className="grid grid-cols-2 gap-3">
              <input type="text" placeholder="MM / YY" className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm" />
              <input type="text" placeholder="CVC" className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm" />
            </div>
          </div>
          <button className="mt-6 w-full py-3 rounded-full text-sm font-bold uppercase tracking-wider text-white" style={{ background: theme.accent || '#2DD4BF' }}>{c.submit_label || 'Pay Securely'}</button>
          <p className="mt-3 text-center text-[10px] opacity-50">Your card details are encrypted end-to-end.</p>
        </div>
      </section>
    );
  }

  if (layout === 'billing-account') {
    return (
      <section data-block-type={block.type} data-layout={block.layout || "default"} className="px-6 py-16" style={{ background: theme.bg, color: theme.ink }}>
        <div className="max-w-2xl mx-auto p-8 border border-gray-200 rounded-2xl" style={{ borderRadius: theme.radius || 16 }}>
          <h2 data-testid={tid('title')} className="text-2xl font-bold text-center" style={{ fontFamily: theme.headingFont }}>{c.title || 'Create Billing Account'}</h2>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-3">
            <input type="text" placeholder="First Name" className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm" />
            <input type="text" placeholder="Last Name" className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm" />
            <input type="text" placeholder="Address Line 1" className="md:col-span-2 w-full px-4 py-3 border border-gray-200 rounded-lg text-sm" />
            <input type="text" placeholder="City" className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm" />
            <input type="text" placeholder="State / Province" className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm" />
            <input type="text" placeholder="ZIP / Postal Code" className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm" />
            <input type="text" placeholder="Country" className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm" />
            <input type="tel" placeholder="Phone" className="md:col-span-2 w-full px-4 py-3 border border-gray-200 rounded-lg text-sm" />
          </div>
          <label className="mt-4 flex items-center gap-2 text-xs opacity-70"><input type="checkbox" /> Enable two-factor authentication</label>
          <button className="mt-6 w-full py-3 rounded-full text-sm font-bold uppercase tracking-wider text-white" style={{ background: theme.accent || '#2DD4BF' }}>{c.submit_label || 'Save Billing Account'}</button>
        </div>
      </section>
    );
  }

  // ── multi-step · Iter 189c Phase B ──────────────────────────────────
  //  Progress stepper + fields grouped by step + primary/next button.
  if (layout === 'multi-step') {
    const steps = c.steps || [
      { label: 'Your Info',   fields: ['Full Name', 'Email'] },
      { label: 'Project',      fields: ['Project Type', 'Timeline'] },
      { label: 'Budget',       fields: ['Budget Range', 'Notes'] },
      { label: 'Review',        fields: [] },
    ];
    const active = Math.min((c.active_step ?? 1), steps.length - 1);
    const current = steps[active] || steps[0];
    return (
      <section data-block-type={block.type} data-layout={block.layout || 'default'} className="px-6 py-24" style={{ background: theme.bg || '#FAF6EE', color: theme.ink || '#0E0E23' }}>
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-8">
            <E block={block} onEdit={onEdit} field="eyebrow" value={c.eyebrow || 'STEP-BY-STEP'} tag="p" className="text-xs uppercase tracking-[0.24em] font-bold" style={{ color: theme.accent || '#8B5CF6' }} placeholder="Eyebrow" />
            <E block={block} onEdit={onEdit} field="title" value={c.title || 'Tell us about your project'} tag="h2" className="mt-3 text-3xl md:text-4xl font-bold" style={{ fontFamily: theme.headingFont }} placeholder="Headline" />
            <E block={block} onEdit={onEdit} field="tagline" value={c.tagline || "It's only 4 quick steps — under two minutes."} tag="p" className="mt-3 opacity-70" placeholder="Tagline" />
          </div>

          {/* Stepper */}
          <div className="mb-8">
            <div className="flex items-center justify-between">
              {steps.map((s, i) => {
                const done = i < active;
                const cur = i === active;
                return (
                  <React.Fragment key={i}>
                    <div className="flex flex-col items-center flex-shrink-0" style={{ minWidth: 60 }}>
                      <div
                        className="w-9 h-9 rounded-full flex items-center justify-center text-xs font-bold"
                        style={{
                          background: done ? (theme.accent || '#8B5CF6') : cur ? (theme.accent || '#8B5CF6') : '#fff',
                          color: done || cur ? '#fff' : (theme.ink || '#0E0E23'),
                          border: done || cur ? 'none' : `1px solid ${theme.ink || '#0E0E23'}30`,
                          fontFamily: theme.headingFont,
                        }}
                      >
                        {done ? '✓' : (i + 1)}
                      </div>
                      <div className="mt-2 text-[11px] uppercase tracking-wider font-bold" style={{ opacity: cur ? 1 : 0.5 }}>{s.label}</div>
                    </div>
                    {i < steps.length - 1 && (
                      <div className="flex-1 h-0.5 mx-2 rounded" style={{ background: i < active ? (theme.accent || '#8B5CF6') : `${theme.ink || '#0E0E23'}20`, marginBottom: 20 }} />
                    )}
                  </React.Fragment>
                );
              })}
            </div>
          </div>

          {/* Current step card */}
          <div className="p-8 rounded-2xl" style={{ background: '#fff', border: `1px solid ${theme.ink || '#0E0E23'}12`, borderRadius: theme.radius || 16, boxShadow: '0 20px 60px rgba(15,15,35,0.06)' }}>
            <p className="text-xs uppercase tracking-[0.24em] font-bold" style={{ color: theme.accent || '#8B5CF6' }}>STEP {active + 1} OF {steps.length}</p>
            <h3 className="mt-2 text-2xl font-bold" style={{ fontFamily: theme.headingFont }}>{current.label}</h3>
            <div className="mt-6 grid grid-cols-1 gap-3">
              {(current.fields.length ? current.fields : ['Everything looks good — ready to submit?']).map((f, i) => (
                <input key={i} type="text" placeholder={f} className="w-full px-4 py-3 rounded-lg text-sm" style={{ border: `1px solid ${theme.ink || '#0E0E23'}20`, background: 'transparent' }} />
              ))}
            </div>
            <div className="mt-6 flex items-center justify-between">
              <button className="text-xs uppercase tracking-wider font-bold opacity-60">← Back</button>
              <button className="px-6 py-3 rounded-full text-xs font-bold uppercase tracking-wider text-white" style={{ background: theme.accent || '#8B5CF6' }}>
                {active === steps.length - 1 ? (c.submit_label || 'Submit') : 'Continue →'}
              </button>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return null;
}
